import React, { Component } from "react";
import { connect } from "react-redux";
import {
  reportList,
  reportDownload,
  sendEmail,
  reportDelete,
  saveSelectedRow
} from "../../redux/actions";

import { preparePager, prepareSearch } from "../../common/tabletools";
//import $ from 'jQuery';
import Reports from "../../components/reports";

class ReportsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pager: {
        defaultColumns: [
          "name",
          "type",
          "customer_name",
          "totaltest",
          "filesize",
          "status",
          "createdat"
        ],
        manual: true,
        pageno: 1,
        pagesize: 10,
        order: {
          field: "createdat",
          sorttype: "desc"
        },
        search: [],
        global: false
      }
    };
  }

//componentDidMount() {
    //var connection = $.hubConnection('http://localhost:8080/', { useDefaultPath: false, skipNegotiation: true });
    //connection.start();
    
    /*var connection = new HubConnection()
    .withUrl('http://localhost:8080/', { useDefaultPath: false, skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
    .build();
    connection.on("reportInitiated", reportId => {
      console.log('message received', reportId);
    });*/


    // var reportGeneratorHubProxy = connection.createHubProxy('reportGeneratorHub');
    // reportGeneratorHubProxy.on('reportInitiated', (id) => {
    //   console.log('ReportId '+ id);
    // });
    //connection.start();

    /*$.connection.hub.start()
      .done(() => {
          console.log("Signalr started");
        })
      .fail(() => {
          console.log("Signalr starting failed");
        })

    const hubConnection = new $.connection.reportGeneratorHub();*/
    
    /*const hubConnection = new HubConnectionBuilder()
    .withUrl('http://localhost:8080/hubs/reportGeneratorHub', { useDefaultPath: false, skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
    .configureLogging(LogLevel.Information)
    .build();

    hubConnection.on("reportInitiated", reportId => {
      console.log('message received', reportId);
    });
    hubConnection.start();
  }*/

  render() {
    const {
      translate,
      reports,
      reportDownload,
      sendEmail,
      del,
      saveSelectedRow,
      previousRow
    } = this.props;

    const { pager } = this.state;

    return reports ? (
      <Reports
        translate={translate}
        reports={reports}
        pager={pager}
        fetch={this.fetch}
        search={this.search}
        refresh={this.refresh}
        deleteReport={del}
        reportDownload={reportDownload}
        sendEmail={sendEmail}
        saveSelectedRow={saveSelectedRow}
        previousRow={previousRow}
      />
    ) : null;
  }
  refresh = () => {
    this.props.reportList(this.state.pager);
  };

  fetch = (table, pager) => {
    if (!pager.global) {
      this.props.reportList(preparePager(table, pager));
    } else {
      let search = pager.search;
      pager = preparePager(table, pager);
      if (pager.search.length > 0) {
        pager.search = [...search, ...pager.search];
      } else {
        pager.search = search;
      } 
      this.props.reportList(pager);
    }
  };

  search = term => {
    const { reports } = this.props;
    const { columns } = reports;
    const { pager } = this.state;

    const _pager = prepareSearch(term, columns, pager);
    _pager.global = term === "" ? false : true;
    this.setState({
      pager: _pager
    });
    this.props.reportList(_pager);
  };

  componentDidMount() {
    this.props.reportList(this.state.pager);
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  reportList: pager => {
    if (!Object.keys(pager.order).length) {
      pager.order = {
        field: "createdat",
        sorttype: "desc"
      };
    }
    dispatch(reportList(pager));
  },
  reportDownload: data => {
    dispatch(reportDownload(data));
  },
  sendEmail: data => {
    return dispatch(sendEmail(data));
  },
  del: (reportIds, pager) => {
    return dispatch(reportDelete(reportIds, pager));
  },
  saveSelectedRow: currentRow => {
    dispatch(saveSelectedRow(currentRow));
  }
});

const mapStateToProps = state => ({
  reports: state.reportReducer.reports,
  previousRow: state.jobReducer.previousRow
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsPage);
